import { render, staticRenderFns } from "./AssignRoleDialogV2.vue?vue&type=template&id=35750801&scoped=true"
import script from "./AssignRoleDialogV2.vue?vue&type=script&lang=js"
export * from "./AssignRoleDialogV2.vue?vue&type=script&lang=js"
import style0 from "./AssignRoleDialogV2.vue?vue&type=style&index=0&id=35750801&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35750801",
  null
  
)

export default component.exports